<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{$t(title)}}
           </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :error="error"
                           :title="'editionClient.problemOccurred'"
                           @close="error = $event"/>
      <b-field :label="$t(getActionLibelle)">
        <qd-switch v-model="switchValue"
                  class="pdr-0 mgr-0 pdl-0
                  column is-narrow">
        </qd-switch>
        <span class="column is-10 pdl-0">
          {{ $t(getSwitchValueText(switchValue)) }}
        </span>
      </b-field>
      <b-field
        :label="$t('modificationOrdreTravailAffichage.popupAffichageGrattage.commentaire')"
        v-if="showCommentaire">
        <b-input v-model="commentaire"
          type="textarea"
          rows="2"
          :placeholder="$t('modificationOrdreTravailAffichage.popupAffichageGrattage.texte')">
        </b-input>
      </b-field>
      <b-field class="mgt-20px">
        <div class="is-pulled-left boutonAction">
          <a class="button" @click="$parent.close()">
            {{ $t('general.button.cancel')}}
          </a>
        </div>
        <div class="is-pulled-left boutonAction">
          <a class="button is-addOrEdit" @click="massModification">
            {{ $t('general.button.valider') }}
          </a>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';
import {
  ACTION_MASS_AFFICHER_NE_PAS_AFFICHER,
  ACTION_MASS_GRATTER_NE_PAS_GRATTER,
  ACTION_MASS_LAISSER_NE_PAS_LAISSER,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { cloneDeep } from 'lodash';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    actionOnFace: {
      type: String,
      required: true,
    },
    seletedFaces: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      error: false,
      constantes: {
        ACTION_MASS_AFFICHER_NE_PAS_AFFICHER,
        ACTION_MASS_LAISSER_NE_PAS_LAISSER,
        ACTION_MASS_GRATTER_NE_PAS_GRATTER,
      },
      switchValue: true,
      commentaire: '',
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    getActionLibelle() {
      switch (this.actionOnFace) {
        case this.constantes.ACTION_MASS_AFFICHER_NE_PAS_AFFICHER:
          return 'modificationOrdreTravailAffichage.popupAffichageGrattage.afficher';
        case this.constantes.ACTION_MASS_LAISSER_NE_PAS_LAISSER:
          return 'modificationOrdreTravailAffichage.popupAffichageGrattage.title.laisserEnPlace';
        case this.constantes.ACTION_MASS_GRATTER_NE_PAS_GRATTER:
          return 'modificationOrdreTravailAffichage.popupAffichageGrattage.gratter';
        default:
          return '';
      }
    },
    title() {
      switch (this.actionOnFace) {
        case this.constantes.ACTION_MASS_AFFICHER_NE_PAS_AFFICHER:
          return 'modificationOrdreTravailAffichage.popupAffichageGrattage.title.affichage';
        case this.constantes.ACTION_MASS_LAISSER_NE_PAS_LAISSER:
          return 'modificationOrdreTravailAffichage.popupAffichageGrattage.title.laisserEnPlace';
        case this.constantes.ACTION_MASS_GRATTER_NE_PAS_GRATTER:
          return 'modificationOrdreTravailAffichage.popupAffichageGrattage.title.grattage';
        default:
          return '';
      }
    },
    showCommentaire() {
      return (this.actionOnFace === ACTION_MASS_AFFICHER_NE_PAS_AFFICHER
        || this.actionOnFace === ACTION_MASS_LAISSER_NE_PAS_LAISSER);
    },
  },
  methods: {
    getSwitchValueText(switchValue) {
      return switchValue ? 'general.oui' : 'general.non';
    },
    massModification() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = cloneDeep(this.seletedFaces).map(face => {
          switch (this.actionOnFace) {
            case ACTION_MASS_AFFICHER_NE_PAS_AFFICHER:
              face.affichage = this.switchValue;
              face.commentaireAffichage = this.commentaire;
              if (this.switchValue) {
                face.laisserEnPlace = false;
              }
              break;
            case ACTION_MASS_LAISSER_NE_PAS_LAISSER:
              face.laisserEnPlace = this.switchValue;
              face.commentaireLaisserEnPlace = this.commentaire;
              if (this.switchValue) {
                face.affichage = false;
              }
              break;
            case ACTION_MASS_GRATTER_NE_PAS_GRATTER:
              face.grattage = this.switchValue;
              break;
            default:
          }
          return face;
        });
        this.$emit('preapreAffichageFaceUpdate', data);
        this.$parent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
